import React from 'react';
import PageTitle from '../Shared/PageTitle';

const Reviews = () => {
    return (
        <div>
            <PageTitle title='Reviews' />
            <div className='min-h-screen flex items-center justify-center'>
                <h2 className='text-2xl'>This is Reviews Page</h2>
            </div>
        </div>
    );
};

export default Reviews;